import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=4ad0e0fc&scoped=true&"
import script from "./ProcessTPBL.vue?vue&type=script&lang=js&"
export * from "./ProcessTPBL.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=4ad0e0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0e0fc",
  null
  
)

export default component.exports